<template>
    <FeedbackRequestButton :makeDefaultMessage="makeDefaultMessage"
        type="general"
        :color="color"
        :source="source"
    />
</template>

<script>
import FeedbackRequestButton from '../Button'
import commaAnd from '@/utils/commaAnd'
import { subject } from '@/utils/pronouns'

export default {
    components: { FeedbackRequestButton },

    props: {
        color: { type: String, default: 'blue' },
        source: { type: String, required: false },
    },

    data() {
        return {
          makeDefaultMessage: ({ coachName, athleteName, athleteGender, staffNames }) => `
              Hi ${commaAnd(staffNames)},
          
              I just viewed ${athleteName}'s profile on ${this.$domain.config('title_name')}
              and am interested in learning more about ${athleteName} as a student-athlete.
              Do you think ${subject(athleteGender)} is a good fit for our program?
              Please reply with any additional info that you feel would be valuable for our evaluation.
          
              Thanks,
          
              ${coachName}
          `
        }
    }
}
</script>